/** EFM discipline codes — mirrors ``innex_db_models.domains.EFMDomain``. */

export type EFMDomainCode =
  // Core building / engineering
  | 'water'
  | 'waste'
  | 'energy_sustainability'
  | 'medical_gas'
  | 'ventilation'
  | 'electrical_lv'
  | 'electrical_hv'
  | 'fire'
  | 'health_safety'
  | 'asbestos'
  | 'acoustics'
  | 'decontamination'
  | 'lifts'
  | 'confined_spaces'
  | 'medical_devices'
  | 'pressure_systems'
  // Safety and security
  | 'security'
  | 'hazardous_substances'
  // Clinical environment
  | 'mental_health'
  | 'infection_prevention'
  | 'mortuary'
  | 'air_quality'
  // Operational / facilities
  | 'food_safety'
  | 'laundry_linen'
  | 'asset_management'
  | 'facility_design'
  | 'hotel_services'
  | 'helipad'
  | 'patient_experience'
  | 'contractor_management'
  | 'transport_logistics'
  | 'workforce_development'
  | 'boiler_operation'
  | 'nista';

export const EFM_DOMAIN_LABELS: Record<EFMDomainCode, string> = {
  // Core building / engineering
  water: 'Water',
  waste: 'Waste',
  energy_sustainability: 'Energy & Sustainability',
  medical_gas: 'Medical Gas Pipeline Systems',
  ventilation: 'Ventilation (& Heating)',
  electrical_lv: 'LV Electrical',
  electrical_hv: 'HV Electrical',
  fire: 'Fire Safety',
  health_safety: 'Health & Safety',
  asbestos: 'Asbestos',
  acoustics: 'Acoustics',
  decontamination: 'Decontamination',
  lifts: 'Lifts & Lifting Equipment',
  confined_spaces: 'Confined Spaces',
  medical_devices: 'Medical Devices',
  pressure_systems: 'Pressure Systems',
  // Safety and security
  security: 'Security',
  hazardous_substances: 'Hazardous Substances',
  // Clinical environment
  mental_health: 'Mental Health',
  infection_prevention: 'Infection Prevention & Control',
  mortuary: 'Mortuary & Body Handling',
  air_quality: 'Air Quality',
  // Operational / facilities
  food_safety: 'Food Safety',
  laundry_linen: 'Laundry & Linen',
  asset_management: 'Asset Management',
  facility_design: 'Facility Design',
  hotel_services: 'Hotel Services',
  helipad: 'Helipad',
  patient_experience: 'Patient Experience',
  contractor_management: 'Contractor Management',
  transport_logistics: 'Transport & Logistics',
  workforce_development: 'Workforce Development',
  boiler_operation: 'Boiler Operation',
  nista: 'NISTA'
};

export function getEfmDomainLabel(code: EFMDomainCode | string): string {
  return (EFM_DOMAIN_LABELS as Record<string, string>)[code] ?? code;
}

export function compareEfmDomains(a: EFMDomainCode | string, b: EFMDomainCode | string): number {
  return getEfmDomainLabel(a).localeCompare(getEfmDomainLabel(b));
}
